import { useEffect, useState } from 'react';
import { RoleModel } from '../types/RoleModel';
import { roleService } from '../api/roles.service';

/**
 * Loads the full role list.
 *
 * Exists so callers that only have role *ids* (the user form stores `roleIds`) can resolve
 * them to names - RoleSelect used to fetch this list privately and discard everything but
 * the id.
 */
export const useRoles = () => {
  const [roles, setRoles] = useState<RoleModel[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isCancelled = false;

    async function getAllRoles() {
      const response = await roleService.getAllRoles();
      if (isCancelled) return;

      if (response.isSuccess) {
        setRoles(response.payload);
      }
      setIsLoading(false);
    }

    getAllRoles();

    return () => {
      isCancelled = true;
    };
  }, []);

  return { roles, isLoading };
};
